export const PERFORMER_CARD_WIDTH_IN_PX = 400;
export const PERFORMER_IMAGE_SIZES = "600px";
